// Generated by purs version 0.13.8
"use strict";
var Data_Char = require("../Data.Char/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var arrow = Data_Maybe.maybe("->")(Data_String_CodeUnits.singleton)(Data_Char.fromCharCode(8594));
module.exports = {
    arrow: arrow
};
